import React, { useCallback, useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
const purchases = [{
  name: 'Marcos T.',
  city: 'Córdoba',
  product: 'Sistema Maestro + Pack de Aceleración',
  time: 'hace 2 minutos'
}, {
  name: 'Roberto G.',
  city: 'Rosario',
  product: 'Sistema Maestro Completo',
  time: 'hace 5 minutos'
}, {
  name: 'Diego V.',
  city: 'Salta',
  product: 'Pack completo',
  time: 'hace 8 minutos'
}, {
  name: 'Esteban F.',
  city: 'Tucumán',
  product: 'Sistema Maestro',
  time: 'hace 12 minutos'
}, {
  name: 'Pablo S.',
  city: 'Mar del Plata',
  product: 'Sistema Maestro + Pack de Aceleración',
  time: 'hace 15 minutos'
}, {
  name: 'Ariel M.',
  city: 'Buenos Aires',
  product: 'Sistema Maestro Completo',
  time: 'hace 18 minutos'
}];
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const showToast = useCallback(() => {
    setDismissed(false);
    setVisible(true);
    const hideTimer = setTimeout(() => setVisible(false), 6000);
    return hideTimer;
  }, []);
  useEffect(() => {
    const initialTimer = setTimeout(() => showToast(), 8000);
    return () => clearTimeout(initialTimer);
  }, [showToast]);
  useEffect(() => {
    if (!visible && !dismissed) {
      const nextTimer = setTimeout(() => {
        setIndex(prev => (prev + 1) % purchases.length);
        showToast();
      }, 45000);
      return () => clearTimeout(nextTimer);
    }
  }, [visible, dismissed, showToast]);
  const handleDismiss = () => {
    setVisible(false);
    setDismissed(true);
    setTimeout(() => {
      setIndex(prev => (prev + 1) % purchases.length);
      setDismissed(false);
      showToast();
    }, 45000);
  };
  const purchase = purchases[index];
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm transition-all duration-500 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-408">
      <div className="bg-surface border border-white/10 rounded-xl p-4 shadow-2xl shadow-black/50" data-id="element-409">
        <div className="flex items-center justify-between mb-3" data-id="element-410">
          <div className="flex items-center gap-2" data-id="element-411">
            <span className="relative flex h-2.5 w-2.5" data-id="element-412">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75" data-id="element-413"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-gold" data-id="element-414"></span>
            </span>
            <span className="text-gold text-xs font-bold uppercase tracking-wider" data-id="element-415">
              COMPRA VERIFICADA
            </span>
          </div>
          <button onClick={handleDismiss} className="text-gray-500 hover:text-white transition-colors p-0.5" aria-label="Cerrar" data-id="element-416">
            <XIcon className="w-4 h-4" data-id="element-417" />
          </button>
        </div>
        <p className="text-white text-sm mb-1" data-id="element-418">
          <span className="font-bold" data-id="element-419">{purchase.name}</span>
          <span className="text-gray-400" data-id="element-420"> de {purchase.city}</span>
        </p>
        <p className="text-gray-300 text-sm" data-id="element-421">
          compró{' '}
          <span className="text-gold font-semibold" data-id="element-422">{purchase.product}</span>
        </p>
        <p className="text-gold/80 text-xs mt-2" data-id="element-423">{purchase.time}</p>
      </div>
    </div>;
}